import { motion } from "framer-motion";

const HERO =
  "https://images.unsplash.com/photo-1539109136881-3be0616acf4b?w=1800&q=85";

export default function WomenComingSoon() {
  return (
    <div
      className="w-full"
      data-testid="women-coming-soon"
    >
      {/* Hero image area */}
      <section className="relative w-full h-[calc(100vh-92px)] min-h-[650px] overflow-hidden">
        <img
          src={HERO}
          alt=""
          className="absolute inset-0 w-full h-full object-cover object-[50%_20%] "
        />

        <div className="absolute inset-0 bg-black/45" />

        <div className="relative z-10 h-full flex items-center justify-center px-6 text-white">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{
              duration: 0.8,
              ease: [0.16, 1, 0.3, 1],
            }}
            className="text-center max-w-2xl"
          >
            <div className="ie-overline opacity-80 mb-5">
              The Women&apos;s Edit
            </div>

            <h1 className="font-serif text-5xl sm:text-6xl md:text-8xl tracking-tight leading-[0.95] mb-6">
              Coming Soon
            </h1>

            <p className="text-sm sm:text-base text-white/80 leading-relaxed max-w-md mx-auto">
              A new expression of Indus Eirene is being carefully composed.
              Our women&apos;s collection is coming soon.
            </p>

            <div className="mt-10">
              <div className="w-16 h-px bg-white/60 mx-auto" />
            </div>

            <p className="ie-overline opacity-70 mt-6">
              Crafted in India · Worn Worldwide
            </p>
          </motion.div>
        </div>
      </section>
    </div>
  );
}